import Save from '@mui/icons-material/Save';
import { Autocomplete, Box, Button, Card, CardContent, CardHeader, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';
import List from '@mui/icons-material/List';
import { graphChangeAuthenType, graphGenOtpQRCode } from '../../services/Profile';

const SmsType = [
  {
    id: 'SMS',
    name: 'SMS Message'
  },
  {
    id: 'AUTHENTICATOR_APP',
    name: 'Google Authenticator'
  },
]

const buttonStyle = {
  cursor: 'default',
  fontSize: FontSize.Big,
  color: Color.Main,
  '&:hover': {
    background: Color.Button, color: Color.Dangerous
  }
};
const boxStyle = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column'
};
const gridStyle = { alignItems: 'center', display: 'flex', justifyContent: 'center' };
const gridSave = {
  mt: 5,
  display: 'flex',
  justifyContent: 'end'
};
const buttonSave = {
  color: Color.Button,
  backgroundColor: Color.Main,
  '&:hover': { background: Color.Button, color: Color.Main }
};
const marginStyle = { mt: 2 };

const MoreInfo = (props) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const [otpType, setOtpType] = useState('SMS');
  const [otpName, setOtpName] = useState('SMS Message');
  const [qrCode, setQrCode] = useState('');
  const [profiles, setProfiles] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.profiles !== null) {
      setProfiles(props.profiles);
      setOtpName(SmsType[SmsType.findIndex(x => x.id === props.profiles.authenType)].name);
      setOtpType(props.profiles.authenType);
    }
  }, [props.profiles])

  useEffect(() => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    if (profiles !== null) {
      if (profiles.authenType === 'AUTHENTICATOR_APP') {
        graphGenOtpQRCode().then((result) => {
          setQrCode(result)
        }).catch((error) => {
          const err = JSON.parse(JSON.stringify(error))
          alert = { ...alert, message: err.response.errors[0].message };
          dispatch(showAlert(alert));
        })
      } else {
        setQrCode('');
      }
    }

  }, [dispatch, profiles])

  const handleChangeAuthenType = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    dispatch(openLoadingApi());
    graphChangeAuthenType(otpType).then((result) => {
      alert = { ...alert, severity: 'success', title: 'Success', message: 'Change otp type successful!' };
      dispatch(showAlert(alert));
      setProfiles({ ...profiles, authenType: profiles.authenType === 'SMS' ? 'AUTHENTICATOR_APP' : 'SMS' })
      dispatch(closeLoadingApi());
    }).catch((error) => {
      const err = JSON.parse(JSON.stringify(error));
      alert = { ...alert, message: err.response.errors[0].message };
      dispatch(showAlert(alert));
      dispatch(closeLoadingApi());
    })
  }


  return profiles !== null ? (
    <Card>
      <CardHeader
        title={<Box sx={boxStyle}>
          <Button sx={buttonStyle} id="more-info" endIcon={<List />}>
            Details
          </Button>
        </Box>
        } />
      <Divider />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'> ID type: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4'> {(profiles.idCardNumber === 1) ? `CMT` : `CCCD`} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'>  Identify Number: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4' sx={marginStyle}> {profiles.idCardNumber} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'> Gender: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4' sx={marginStyle}>  {profiles.gender} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'> DOB: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4'> {profiles.dob} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'> Nationality: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4'>  {profiles.nationality} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'>  Address: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4'>  {profiles.baseAddress} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'>  Phone: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4'>  {profiles.phoneNumber} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={marginStyle}>
            <Typography variant='h4'>  Email: </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Typography variant='h4'> {profiles.email} </Typography>
          </Grid>
          <Grid item xs={4} sm={4} sx={gridStyle}>
            <Typography variant='h4'> Otp Type  </Typography>
          </Grid>
          <Grid item xs={8} sm={8} sx={marginStyle}>
            <Autocomplete
              fullWidth
              id="tags-standard"
              options={SmsType.map((option) => option.name)}
              filterSelectedOptions
              value={otpName}
              onChange={(e, newValue) => {
                setOtpName(newValue);
                setOtpType(SmsType[SmsType.findIndex(x => x.name === newValue)].id);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Type"
                  size={matchDownMD ? "small" : "medium"}
                  sx={{
                    '& .MuiInputBase-input': {
                      bgcolor: theme.palette.background.default,
                      px: 2
                    },
                    '& .MuiOutlinedInput-root': {
                      bgcolor: theme.palette.background.default,
                      px: 2
                    },
                  }}
                />
              )}
            />
          </Grid>
          {qrCode !== '' && (
            <>
              <Grid item xs={12}>
                Authentication QR code
              </Grid>
              <Grid item xs={12} sm={12} sx={gridStyle}>
                <img alt="" src={qrCode}
                  width="190px" height="auto"
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} sx={gridSave}>
            <Button sx={buttonSave} variant='contained' startIcon={<Save />} onClick={handleChangeAuthenType}>Save</Button>
          </Grid>
        </Grid>
      </CardContent >
    </Card >
  ) : (
    <Card>

    </Card>
  )
};

export default MoreInfo;